"use strict";

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateVersion = exports.supportedVersionsTypeMapping = exports.supportedVersions = void 0;
/**
 *
 */

exports.supportedVersions = {
  zora: ['20210101', '20210604'],
  catalog: ['20210202'],
  amulet: ['20210221']
};
/**
 *
 */

exports.supportedVersionsTypeMapping = {
  zora: {
    '20210101': 'Zora20210101',
    '20210604': 'Zora20210604'
  },
  catalog: {
    '20210202': 'Catalog20210202'
  },
  amulet: {
    '20210221': 'Amulet20210221'
  }
};
/**
 *
 * @param verboseVersion
 */

function validateVersion(verboseVersion) {
  var _verboseVersion$split = verboseVersion.split('-'),
      _verboseVersion$split2 = _slicedToArray(_verboseVersion$split, 2),
      name = _verboseVersion$split2[0],
      calVer = _verboseVersion$split2[1]; // require name exists in `versions`


  if (!(name in exports.supportedVersions)) {
    throw new Error("There are no versions with the ".concat(name, " project name"));
  } // require calVer exists in `versions`


  if (exports.supportedVersions[name].indexOf(calVer) == -1) {
    throw new Error("There are no versions in the ".concat(name, " namespace with the ").concat(calVer, " calendar version"));
  }

  return;
}

exports.validateVersion = validateVersion;